import Text from 'components/Text'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import Collapsible from 'components/Collapsible/index.js'
import { LEVEL_MESSAGE } from '@gymaholic/packages'

const messages = defineMessages({
  whatFitnessLevel: {
    id: 'ExerciseContentLevel.whatFitnessLevel',
    defaultMessage: 'What fitness level is the {exerciseName} suitable for?'
  },
  suitableFor: {
    id: 'ExerciseContentLevel.suitableFor',
    defaultMessage: 'The {exerciseName} is suitable for {level} athletes.'
  }
})

/**
 * @param {ExerciseContentProps} props
 * @return {Element}
 * @constructor
 */
export function ExerciseContentLevel ({
  exerciseName,
  level
}) {
  const intl = useIntl()

  const levelLabel = formatMessageIntlUtil(intl, LEVEL_MESSAGE[level])

  return (
    <Collapsible
      label={formatMessageIntlUtil(intl, messages.whatFitnessLevel, { exerciseName })}
    >
      <Text
        mb
      >
        {formatMessageIntlUtil(intl, messages.suitableFor, {
          exerciseName,
          level: levelLabel.toLowerCase()
        })}
      </Text>
    </Collapsible>
  )
}
